export const faqs = [
  {
    q: '¿En qué formato lo recibo?',
    a: 'Son 9 archivos PDF: 6 tomos y 3 bonos. Los descargás, los guardás y los imprimís las veces que quieras. No hay videos, no hay plataforma, no hay suscripción.',
  },
  {
    q: '¿Sirve si recién arranco como instructora?',
    a: 'Sí. El Tomo 1 empieza por los seis principios y la respiración, y de ahí progresa hasta el nivel avanzado. Vas a tener el camino completo.',
  },
  {
    q: '¿Y si ya tengo años dando clases?',
    a: 'El valor para vos no está en aprender el repertorio, está en no volver a armar una clase desde cero. Más las 20 patologías en semáforo y las clases ya escritas con minutaje.',
  },
  {
    q: '¿Cuánto tarda en llegarme?',
    a: 'Al instante. Apenas se aprueba el pago te llega el enlace de descarga al mail. Si no lo ves, revisá spam.',
  },
  {
    q: '¿Puedo imprimirlo?',
    a: 'Está diseñado para eso. Formato A4, 300 DPI, con fichas recortables y láminas A3 para colgar en el estudio.',
  },
  {
    q: '¿Puedo usarlo con mis alumnos?',
    a: 'Sí, en tus clases y en tu estudio. Lo que no podés hacer es revenderlo ni distribuirlo como material propio.',
  },
  {
    q: '¿Reemplaza a una formación?',
    a: 'No, y no lo pretende. Es material de trabajo para instructores que ya están formados. Tampoco reemplaza la indicación médica: ante patología diagnosticada se trabaja con derivación y alta.',
  },
  {
    q: '¿Qué pasa si no me sirve?',
    a: 'Tenés 7 días para escribirnos y te devolvemos el 100%. Sin vueltas.',
  },
]
